import axios from "../utils/axios";

// ==========================================
// Roles
// ==========================================

export const getRoles = async (params) => {
    const response = await axios.get("/admin/roles", { params });
    return response.data;
};

export const getRoleById = async (id) => {
    const response = await axios.get(`/admin/roles/${id}`);
    return response.data;
};

export const createRole = async (data) => {
    const response = await axios.post("/admin/roles", data);
    return response.data;
};

export const updateRole = async (id, data) => {
    const response = await axios.put(`/admin/roles/${id}`, data);
    return response.data;
};

export const deleteRole = async (id) => {
    const response = await axios.delete(`/admin/roles/${id}`);
    return response.data;
};

// ==========================================
// Permissions
// ==========================================

export const getPermissions = async () => {
    const response = await axios.get("/admin/permissions");
    return response.data;
};

// ==========================================
// User Roles
// ==========================================

export const getUserRoles = async (userId) => {
    const response = await axios.get(`/admin/users/${userId}/roles`);
    return response.data;
};

export const syncUserRoles = async (userId, data) => {
    const response = await axios.post(`/admin/users/${userId}/roles`, data);
    return response.data;
};
